import config from '@/config';
import { FunctionalitiesEnum } from '@/config/types';
import { getSpecialRoutePath } from '@/logic/main/utils';
import MessageBus from '@/ports-frontend/MessageBus';

export async function headerWatcher({ callback }: { callback: Function }) {
  const unsubscribeHamburgerClick = await MessageBus.onSubscribe(() => {
    return callback({
      type: 'VIEW_HAMBURGER_MENU_CLICK',
      payload: {
        command: 'leftSLider',
      },
    });
  }, ['wh.header.event.hamburger.clicked']);

  const unsubscribeSearchClick = await MessageBus.onSubscribe(() => {
    return callback({
      type: 'VIEW_HEADER_SEARCH_CLICK',
      payload: {
        path: `${config.base_path || ''}${getSpecialRoutePath(
          FunctionalitiesEnum.search
        )}`,
      },
    });
  }, ['wh.common.event.ui.header.search.clicked']);

  const unsubscribeSPartialEvent = await MessageBus.onSubscribe(
    data => {
      return callback({
        type: 'VIEW_PARTIAL_EVENT_CALLED',
        payload: data.payload,
      });
    },
    ['wh.common.command.dli.tl.eventPartial']
  );

  const unsubscribeFeedbackClick = await MessageBus.onSubscribe(
    data => {
      return callback({
        type: 'VIEW_FEEDBACK_EVENT_CALLED',
        payload: data.payload,
      });
    },
    ['wh.myAccount.event.footer.request.feedback']
  );

  let eventSent: boolean = false;
  const unsubscribeHeaderInit = await MessageBus.onSubscribe(() => {
    if (!eventSent) {
      callback({ type: 'WH_HEADER_INITIALIZED' });
    }
    eventSent = true;
  }, ['wh.kraken.event.boostrapped']);

  const unsubscribeAccountBalanceChange = await MessageBus.onSubscribe(
    ({ payload }) => {
      const { balance } = payload as { balance: string };
      callback({
        type: 'WH_UPDATE_ACCOUT_BALANCE',
        payload: { balance },
      });
    },
    [
      'wh.common.event.account.info.state.changed',
      'wh.common.event.account.info.state.get',
    ]
  );

  return () => {
    unsubscribeHamburgerClick();
    unsubscribeSearchClick();
    unsubscribeSPartialEvent();
    unsubscribeFeedbackClick();
    unsubscribeHeaderInit();
    unsubscribeAccountBalanceChange();
  };
}
export async function headerProductWatcher({
  callback,
}: {
  callback: Function;
}) {
  const unsubscribe = await MessageBus.onSubscribe(
    data => {
      callback({
        type: 'VIEW_HEADER_PRODUCT_EVENT_CALLED',
        data: data.payload,
      });
    },
    ['wh.common.event.ui.header.product.requested']
  );

  return () => {
    unsubscribe();
  };
}
